/**
 * Punto de entrada del kiosco.
 *
 * Sin StrictMode a proposito: el doble montaje de desarrollo abriria dos
 * sesiones de voz y dos WebSockets de avatar contra el backend. Si hace falta
 * cazar efectos duplicados, activarlo puntualmente y volver a quitarlo.
 */
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { aplicarEscala } from '@/lib/escala';
import '@/index.css';

// El tamano de la interfaz se fija ANTES de pintar: si se hiciera dentro de
// React, la primera pasada saldria a tamano kiosco y se veria dar un salto.
aplicarEscala();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('No existe el elemento #root en index.html');

createRoot(raiz).render(<App />);
